/** @jsxImportSource react */

import Search from '@sly/icons/react/Search';
import cx from 'classnames';
import { bool, func, string } from 'proptypes';
import React, { forwardRef } from 'react';

import Button from '../Button';
import Input from '../Input';

const SearchInput = forwardRef(
  (
    {
      placeholder,
      type,
      value,
      name,
      onBlur,
      onChange,
      onKeyDown,
      onFocus,
      inputStyles,
      buttonStyles,
      onSubmit = () => {},
      ...props
    },
    ref
  ) => (
    <div
      className={cx('flex', props.className || '')}
      ref={ref}
      data-tp-id='gen-div-68b9ce18-8fdc-4974-af7d-defe5f6b6b96'
    >
      <Input
        ref={ref}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        className={cx(
          inputStyles,
          '!rounded-[0.25rem] !rounded-br-none !rounded-tr-none'
        )}
        type={type}
        data-tp-id='gen-Input-23a2bcc4-f70a-41d6-970a-79c7b406efad'
      />
      <Button
        className={cx(
          'rounded-box min-w-[49px] text-clip !border-viridian-base',
          '!rounded-[0.25rem] !rounded-bl-none !rounded-tl-none !border-l-0',
          buttonStyles || ''
        )}
        data-tp-id='gen-Button-cece0b1d-ebdf-4978-81ec-b1f60c41a2ee'
        onClick={onSubmit}
      >
        <Search color='text-white' />
      </Button>
    </div>
  )
);

SearchInput.propTypes = {
  type: string,
  disabled: bool,
  placeholder: string,
  value: string,
  name: string,
  onBlur: func,
  onChange: func,
  onKeyDown: func,
  onFocus: func,
  inputStyles: string,
  buttonStyles: string,
  onSubmit: func,
};

SearchInput.defaultProps = {
  type: 'text',
};

SearchInput.displayName = 'SearchInput';

export default SearchInput;
